import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';
import Button from '@fandom-frontend/react-common/dist/components/Button';
import { ThemeVariables } from 'pathfinder/modules/shared/Theme/themeVariables';
import WDSVariables from '@fandom-frontend/design-system/dist/variables.json';
import { CurrentPageType } from 'pathfinder/modules/RegistrationButton/types';
export const StyledButton = styled(Button) `
	--wds-text-button-label-color--hover: var(${ThemeVariables.themeCommunityHeaderColorhover});
	--wds-secondary-button-label-color: var(${ThemeVariables.themeCommunityHeaderColor});

	&.wds-is-secondary {
		margin-right: 9px;
	}

	${({ $hasButtonCommonColors }) => $hasButtonCommonColors &&
    css `
			--wds-primary-button-background-color: ${WDSVariables.wdsFandomColorPurple};
			--wds-primary-button-background-color--hover: ${lighten(0.2, WDSVariables.wdsFandomColorPurple)};
			--wds-primary-button-label-color: ${WDSVariables.wdsColorWhite};
			--wds-secondary-button-label-color: ${WDSVariables.wdsFandomColorBlack};
			--wds-secondary-button-label-color--hover: ${lighten(0.1, WDSVariables.wdsFandomColorBlack)};

			// additional styles with higher specificity to overwrite styles on f2
			&.wds-button:not(.wds-is-text):not(.wds-is-secondary) {
				background-color: var(--wds-primary-button-background-color);
				border-color: var(--wds-primary-button-background-color);
				color: var(--wds-primary-button-label-color);

				:hover {
					background-color: var(--wds-primary-button-background-color--hover);
					border-color: var(--wds-primary-button-background-color--hover);
				}
			}

			&.wds-is-secondary {
				color: var(--wds-secondary-button-label-color);
				border-color: var(--wds-secondary-button-label-color);

				:hover:not(:disabled) {
					color: var(--wds-secondary-button-label-color--hover);
					border-color: var(--wds-secondary-button-label-color--hover);
				}
			}
		`}

	${({ $hasGlobalNavColors }) => $hasGlobalNavColors &&
    css `
			--wds-primary-button-background-color: ${WDSVariables.wdsFandomColorYellow};
			--wds-primary-button-background-color--hover: ${lighten(0.15, WDSVariables.wdsFandomColorYellow)};
			--wds-primary-button-label-color: ${WDSVariables.wdsFandomColorBlack};

			// additional styles with higher specificity to overwrite styles on f2
			&.wds-is-secondary {
				--wds-secondary-button-label-color: ${WDSVariables.wdsColorLightGray};
				--wds-secondary-button-label-color--hover: ${darken(0.1, WDSVariables.wdsColorLightGray)};
				color: var(--wds-secondary-button-label-color);
				border-color: var(--wds-secondary-button-label-color);

				:hover:not(:disabled) {
					color: var(--wds-secondary-button-label-color--hover);
					border-color: var(--wds-secondary-button-label-color--hover);
				}
			}

			// additional styles with higher specificity to overwrite styles on f2
			&.wds-button:not(.wds-is-text):not(.wds-is-secondary) {
				background-color: var(--wds-primary-button-background-color);
				border-color: var(--wds-primary-button-background-color);
				color: var(--wds-primary-button-label-color);

				:hover {
					background-color: var(--wds-primary-button-background-color--hover);
					border-color: var(--wds-primary-button-background-color--hover);
				}
			}
		`}

  ${({ $isEqualSize }) => $isEqualSize &&
    css `
			box-sizing: border-box;
			flex: 1;
		`}
`;
export const Wrapper = styled.div `
	position: absolute;
	top: 0;
	right: 0;
	z-index: 200;

	${({ $currentPageType }) => $currentPageType === CurrentPageType.WIKI_RELATED &&
    css `
			transform: translateY(16px);

			${StyledButton} {
				&:not(.wds-is-secondary) {
					filter: brightness(135%);
				}
			}
		`}

	${({ $currentPageType }) => $currentPageType === CurrentPageType.FAN_CENTRAL &&
    css `
			transform: translateY(-110px);
		`}

  ${({ $currentPageType }) => $currentPageType === CurrentPageType.F2_HOMEPAGE &&
    css `
			transform: translate(-46px, 12px);
		`}

  ${({ $currentPageType }) => $currentPageType === CurrentPageType.F2_TOPIC_PAGE &&
    css `
			position: relative;
			transform: translateY(-30px);
			display: flex;
		`}
`;
